import * as React from 'react'

import { type VariantProps, tv } from 'tailwind-variants'

import ThumbDownIcon from '@wwt/shared/assets/icons/outline/thumb-down.svg'

export const DislikeIconVariants = tv({
	base: '*:transition-all *:ease-out *:duration-100 pointer-events-none [--first:var(--color-white)]',
	variants: {
		variant: {
			default:
				'[--second:var(--color-gray-500)] group-hover:[--first:var(--color-brand-200)]  group-hover:[--second:var(--color-brand-200)] group-active:[--first:var(--color-gray-500)] group-active:[--second:var(--color-gray-500)] group-active:group-hover:[--first:var(--color-brand-300)] group-active:group-hover:[--second:var(--color-brand-300)] group-data-active:[--first:var(--color-gray-500)] group-data-active:[--second:var(--color-gray-500)] group-data-active:group-hover:[--first:var(--color-brand-300)] group-data-active:group-hover:[--second:var(--color-brand-300)]',
			light:
				'[--second:var(--color-gray-500)] group-hover:[--first:var(--color-brand-200)]  group-hover:[--second:var(--color-brand-200)] group-active:[--first:var(--color-white)] group-active:[--second:var(--color-white)] group-active:group-hover:[--first:var(--color-brand-300)] group-active:group-hover:[--second:var(--color-brand-300)] group-data-active:[--first:var(--color-white)] group-data-active:[--second:var(--color-white)] group-data-active:group-hover:[--first:var(--color-brand-300)] group-data-active:group-hover:[--second:var(--color-brand-300)]',
			primary:
				'[--second:var(--color-primary-100)] group-hover:[--first:var(--color-brand-300)]  group-hover:[--second:var(--color-brand-300)]'
		},

		size: {
			default: 'h-6 w-6',
			sm: 'h-4 w-4',
			lg: 'h-9 w-9'
		}
	},
	defaultVariants: {
		variant: 'default',
		size: 'default'
	}
})

export interface DislikeIconProps
	extends React.SVGAttributes<SVGSVGElement>,
		VariantProps<typeof DislikeIconVariants> {}

export const DislikeIcon = ({
	className,
	variant,
	size,
	...props
}: DislikeIconProps) => {
	return (
		<ThumbDownIcon
			className={DislikeIconVariants({ variant, size, className })}
			{...props}
		/>
	)
}

DislikeIcon.displayName = 'DislikeIcon'
